import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { setupGlobalErrorHandlers } from "./utils/errorHandlers";
import { UserProvider } from 'context/user-context';

setupGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  // <React.StrictMode> //à décommenter en local pour tester les effets de bords de spam d'actions
    <UserProvider>
      <App />
    </UserProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
